<template>
    <span class="mx-1 font-weight-bold text-muted">|</span>
</template>

<script>
export default {
    name: 'PipeDivider',
}
</script>
